module.exports = __webpack_public_path__ + "static/img/chuangye.b6288964.png";